<template>
  <CommonDialog
    v-if="isOpen"
    :isDialogOpened="isOpen"
    @handleCloseDialog="handleCloseDeleteModal"
    width="400px"
  >
    <v-card height="300" class="pa-8 d-flex flex-column align-center">
      <div class="d-flex flex-column align-center">
        <v-icon size="80" color="yellow darken-1">mdi-alert</v-icon>
        <h1 class="py-2">{{ $t("alert.warning") }}</h1>
      </div>
      <div class="flex-grow-1">
        <h1 class="py-2 body-1">{{ message }}</h1>
      </div>
      <div>
        <CommonButton
          @handleClick="handleCloseDeleteModal"
          color="transparent"
          :label="$t('common.cancel')"
          width="100"
          customClassName="secondary--text font-weight-medium"
        />
        <CommonButton
          color="primary"
          :label="$t('common.yes')"
          width="100"
          customClassName="ml-2"
          @handleClick="handleApproveDelete"
        />
      </div>
    </v-card>
  </CommonDialog>
</template>

<script>
import CommonButton from "../common/CommonButton";
import CommonDialog from "./dialog/CommonDialog";

export default {
  name: "CommonDeleteModal",
  components: { CommonButton, CommonDialog },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    approveAction: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleCloseDeleteModal() {
      this.closeModal && this.closeModal();
    },

    async handleApproveDelete() {
      this.approveAction && (await this.approveAction());
      this.closeModal && this.closeModal();
    }
  }
};
</script>

<style scoped></style>
